import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=6e84687a&scoped=true&"
import script from "./UserEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84687a",
  null
  
)

export default component.exports